/* @flow */
import React from "react";
import ReactDOM from "react-dom";
import Root from "./app/Root";
import configureReporting from "../common/configureReporting";
import configureStore from "../common/configureStore";
import { fromJSON } from "../common/transit";

import * as firebase from "firebase/app";
import "firebase/messaging";

const config = {
  apiKey: "AIzaSyB0a888y334IPPJd94wQd4IgZ8vwpLTL60",
  authDomain: "opiekujsie-site.firebaseapp.com",
  databaseURL: "https://opiekujsie-site.firebaseio.com",
  projectId: "opiekujsie-site",
  storageBucket: "opiekujsie-site.appspot.com",
  messagingSenderId: "1055842920512"
};
firebase.initializeApp(config);

const initialState = fromJSON(window.__INITIAL_STATE__); // eslint-disable-line no-underscore-dangle

const reportingMiddleware = configureReporting({
  appVersion: initialState.config.appVersion,
  sentryUrl: initialState.config.sentryUrl,
  unhandledRejection: fn => window.addEventListener("unhandledrejection", fn)
});

const store = configureStore({
  initialState,
  platformDeps: {},
  platformMiddleware: [reportingMiddleware]
});

const appElement = document.getElementById("app");

// Initial render.
ReactDOM.render(<Root store={store} />, appElement);

// Hot reload render.
// gist.github.com/gaearon/06bd9e2223556cb0d841#file-naive-js
if (module.hot) {
  module.hot.accept("./app/Root", () => {
    const NextRoot = require("./app/Root").default;

    ReactDOM.render(<NextRoot store={store} />, appElement);
  });
}



/** WEBPACK FOOTER **
 ** ./src/browser/main.js
 **/